import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Radio } from 'lucide-react';

const NAV_LINKS = [
  { href: '#organizations', label: 'Organisationen' },
  { href: '#showcase', label: 'Mechaniken' },
  { href: '#modes', label: 'Spielmodi' },
  { href: '#faq', label: 'FAQ' },
];

export function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={[
        'fixed inset-x-0 top-0 z-50 transition-all duration-300',
        scrolled
          ? 'border-b border-border-subtle bg-bg-overlay backdrop-blur-md'
          : 'border-b border-transparent bg-transparent',
      ].join(' ')}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-emergency">
            <Radio className="h-4 w-4 text-white" aria-hidden />
          </span>
          <span className="font-display text-lg font-semibold tracking-tight">
            Dispatch<span className="text-accent-emergency">24</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 text-sm text-fg-secondary md:flex">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="transition-colors hover:text-fg-primary"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <Link
          to="/play"
          className="rounded-md bg-accent-emergency px-4 py-2 text-sm font-semibold text-white shadow-md transition hover:bg-accent-emergency-hover hover:shadow-[0_0_24px_rgba(220,38,38,0.4)]"
        >
          Jetzt spielen
        </Link>
      </div>
    </header>
  );
}
